import '../../js/vendors/fancybox/jquery.fancybox';

const overviewBlogCC = 'c-posts-overview';

function showOverviewBlog() {}

export default showOverviewBlog;
